import axios from 'axios';

// Create axios instance with interceptors for session management
const api = axios.create();

// Response interceptor to handle session expired errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    // Check if the error is due to session being invalidated by another login
    if (error.response?.status === 401) {
      const detail = error.response?.data?.detail;
      
      if (detail === 'SESSION_EXPIRED_NEW_LOGIN') {
        // Clear all auth tokens
        localStorage.removeItem('livestreamToken');
        localStorage.removeItem('livestreamCustomer');
        localStorage.removeItem('adminToken');
        
        // Show alert to user
        alert('Your session has expired because someone logged in with your credentials on another device. Please log in again.');
        
        // Redirect to appropriate login page
        const currentPath = window.location.pathname;
        if (currentPath.includes('/admin')) {
          window.location.href = '/admin';
        } else if (currentPath.includes('/live')) {
          window.location.href = '/live/login';
        } else {
          window.location.href = '/live/login';
        }
        
        return Promise.reject(error);
      }
    }
    
    return Promise.reject(error);
  }
);

export default api;

// Helper to set up interceptors on the global axios instance
export const setupAxiosInterceptors = () => {
  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response?.status === 401) {
        const detail = error.response?.data?.detail;
        
        if (detail === 'SESSION_EXPIRED_NEW_LOGIN') {
          // Clear all auth tokens
          localStorage.removeItem('livestreamToken');
          localStorage.removeItem('livestreamCustomer');
          localStorage.removeItem('adminToken');
          
          // Show alert to user
          alert('Your session has expired because someone logged in with your credentials on another device. Please log in again.');
          
          // Redirect to appropriate login page
          const currentPath = window.location.pathname;
          if (currentPath.includes('/admin')) {
            window.location.href = '/admin';
          } else if (currentPath.includes('/live')) {
            window.location.href = '/live/login';
          } else {
            window.location.href = '/live/login';
          }
          
          return Promise.reject(error);
        }
      }
      
      return Promise.reject(error);
    }
  );
};
